<!-- product-detail.component.html -->
<h2>Detalle del Producto</h2>
<p>ID del producto: {{ productId }}</p>
<!-- Podrías mostrar más info usando un servicio o API -->
